import moment from "moment";

export function formatNewDate() {
  var d = new Date(),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = "0" + month;
  if (day.length < 2)
    day = "0" + day;

  return [year, month, day].join("-");
}

export function formatNewDate2(date) {
  var d = date,
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = "0" + month;
  if (day.length < 2)
    day = "0" + day;

  return [year, month, day].join("-");
}

export const formatDate = (date) => {
  const [year, month, day] = date.split("T")[0].split("-");

  return `${day}/${month}/${year}`;
};

export const formatDate2 = (date) => {
  const [year, month, day] = date.split("-");

  return `${day}/${month}/${year}`;
};

export const formatDate3 = (date) => {
  if (!date) return null;

  const [day, month, year] = date.split("/");

  return `${year}-${month}-${day}`;
};


export function sleeper(ms) {
  return function (x) {
    return new Promise(resolve => setTimeout(() => resolve(x), ms));
  };
}


export function addPoints(nStr) {
  nStr += "";
  let x = nStr.split(".");

  let x1 = x[0];

  var rgx = /(\d+)(\d{3})/;

  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "." + "$2"); // changed comma to dot here
  }
  return x1;
}

export function formatCapital(capital) {
  let [entero, decimal] = capital.toString().split(".");
  entero = addPoints(entero);

  if (decimal && decimal.length > 1) {
    if (decimal[2] && +decimal[2] > 5) {
      let round = +decimal.slice(0, 2) + 1;

      decimal = `,${round}`;

      if (round.toString().length === 1) {
        decimal = `,${"0" + round}`;
      }
    } else {
      decimal = `,${decimal.slice(0, 2)}`;
    }
  }
  else if (decimal && decimal.length === 1) {
    decimal = `,${"0" + decimal}`;
  }
  else {
    decimal = `,${"00"}`;
  }
  return entero + decimal;
}


function sliceByYear(arr) {
  let result = [];
  let temp = null;
  let tempIndx = 0;

  for (let i = 0; i < arr.length; i++) {
    if (temp && arr[i].ANIO !== temp) {
      let chunk = arr.slice(tempIndx, i);
      tempIndx = i;
      temp = arr[i].ANIO;

      result.push(chunk);
    }
    temp = arr[i].ANIO;
  }
  let chunk = arr.slice(tempIndx, arr.length);
  result.push(chunk);
  return result;
}

export function formatCache(array) {
  if (array && array.length) {
    let resultSlice = sliceByYear(array);

    let result = resultSlice.reduce((a, b) => {
      b.forEach((e) => {
        if (a[e.SITUACION]) {
          a[e.SITUACION] = {
            ...a[e.SITUACION],
            [e.NRO_INMUEBLE]: {
              ...a[e.SITUACION][e.NRO_INMUEBLE],
              [e.RECURSO]: {
                ...a[e.SITUACION][e.NRO_INMUEBLE] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO],
                [e.ANIO]: {
                  periodos: a[e.SITUACION] && a[e.SITUACION][e.NRO_INMUEBLE] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].periodos ? [...a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].periodos, e.CUOTA] : [e.CUOTA],
                  monto: a[e.SITUACION] && a[e.SITUACION][e.NRO_INMUEBLE] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].monto ? [...a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].monto, e.MONTO_ORIGINAL] : [e.MONTO_ORIGINAL],
                  legal: a[e.SITUACION] && a[e.SITUACION][e.NRO_INMUEBLE] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].legal ? [...a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].legal, e.LEGAL] : [e.LEGAL],
                  estado: a[e.SITUACION] && a[e.SITUACION][e.NRO_INMUEBLE] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].estado ? [...a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].estado, e.ESTADO] : [e.ESTADO],
                }
              }
            }
          };
        }
        else {
          a[e.SITUACION] = {
            [e.NRO_INMUEBLE]: {
              [e.RECURSO]: {
                [e.ANIO]: {
                  periodos: a[e.SITUACION] && a[e.SITUACION][e.NRO_INMUEBLE] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].periodos ? [...a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].periodos, e.CUOTA] : [e.CUOTA],
                  monto: a[e.SITUACION] && a[e.SITUACION][e.NRO_INMUEBLE] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].monto ? [...a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].monto, e.MONTO_ORIGINAL] : [e.MONTO_ORIGINAL],
                  legal: a[e.SITUACION] && a[e.SITUACION][e.NRO_INMUEBLE] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].legal ? [...a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].legal, e.LEGAL] : [e.LEGAL],
                  estado: a[e.SITUACION] && a[e.SITUACION][e.NRO_INMUEBLE] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO] && a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].estado ? [...a[e.SITUACION][e.NRO_INMUEBLE][e.RECURSO][e.ANIO].estado, e.ESTADO] : [e.ESTADO],
                }
              }
            }
          };
        }
      }
      );
      return a;
    }, {}
    );
    return result;
  }
}

export function calcularMonto(montosArray) {
  let monto = montosArray.reduce((prev, current) => {
    return +prev + +current;
  }, 0);

  return monto;
}

export function calcularMontoArray(montosArray, propName) {
  let monto = montosArray.reduce((prev, current) => {
    return +prev + +current[propName];
  }, 0);

  return monto.toFixed(2);
}

export function calcularTotal(array) {
  let monto = array.reduce((prev, current) => {
    let total = calcularMonto(current.monto);
    return prev + total;
  }, 0);
  return monto;
}

export function formatPlanDePago(array) {
  if (array && array.length) {
    let result = array.reduce((a, b) => {

      if (a[b.NRO_PLAN]) {
        a[b.NRO_PLAN] = {
          ...a.NRO_PLAN,
          nro_plan: b.NRO_PLAN,
          anio: b.ANIO,
          legal: a[b.NRO_PLAN] && a[b.NRO_PLAN].legal ? a[b.NRO_PLAN].legal : b.LEGAL,
          periodos: a[b.NRO_PLAN] && a[b.NRO_PLAN].periodos ? [...a[b.NRO_PLAN].periodos, b.CUOTA] : [b.CUOTA],
          monto: a[b.NRO_PLAN] && a[b.NRO_PLAN].monto ? [...a[b.NRO_PLAN].monto, b.TOTAL] : [b.TOTAL],
          estado: a[b.NRO_PLAN] && a[b.NRO_PLAN].estado ? [...a[b.NRO_PLAN].estado, b.ESTADO] : [b.ESTADO],
        };
      }
      else {
        a[b.NRO_PLAN] = {
          nro_plan: b.NRO_PLAN,
          anio: b.ANIO,
          legal: b.LEGAL ? b.LEGAL : "",
          periodos: a[b.NRO_PLAN] && a[b.NRO_PLAN].periodos ? [...a[b.NRO_PLAN].periodos, b.CUOTA] : [b.CUOTA],
          monto: a[b.NRO_PLAN] && a[b.NRO_PLAN].monto ? [...a[b.NRO_PLAN].monto, b.TOTAL] : [b.TOTAL],
          estado: a[b.NRO_PLAN] && a[b.NRO_PLAN].estado ? [...a[b.NRO_PLAN].estado, b.ESTADO] : [b.ESTADO],
        };
      }

      return a;
    }, {}
    );
    return result;
  } else {
    return false;
  }
}

export const verificationRole = (user, role) => {
  let userRole = user?.rol.split(",");

  let result = userRole.some(e => role.some(r => e === r));

  return result;
};

export const formatDeuda = (deuda) => {
  if (!deuda || !deuda.length) return [];

  return deuda.reduce((prev, current) => {
    if (prev?.length) {
      if (prev.some(e => e.anio === current.ANIO)) {
        return prev.map(e => {
          if (e.anio === current.ANIO) {
            return {
              anio: current.ANIO,
              periodos: [...e.periodos, current],
              monto: e.monto + +current.TOTAL,
              actual: e.actual + +current.ACTUAL,
              interes: e.interes + +current.INTERES,
              origen: e.origen + +current.ORIGEN,
            };
          }
          else {
            return e;
          }
        });
      }
      else {
        return [
          ...prev,
          {
            anio: current.ANIO,
            periodos: [current],
            monto: +current.TOTAL,
            actual: +current.ACTUAL,
            interes: +current.INTERES,
            origen: +current.ORIGEN
          }
        ];
      }
    }
    else {
      return [
        {
          anio: current.ANIO,
          periodos: [current],
          monto: +current.TOTAL,
          actual: +current.ACTUAL,
          interes: +current.INTERES,
          origen: +current.ORIGEN
        }
      ];
    }
  }, []);
};


export const formatVencimiento = (cuota) => {
  let year = new Date().getFullYear();
  let month = new Date().getMonth() + 1 + cuota;
  let day = new Date().getDay();

  if (day > 11) {
    month = month + 1;
  }
  if (month > 12) {
    year = year + Math.trunc(month / 12);
    month = month - (Math.trunc(month / 12) * 12);
  }

  return `11/${month ? month < 10 ? "0" + month : month : "12"}/${year}`;
};

export const fixNumber = (value) => {
  if (value) {
    return +Number(value).toFixed(2);
  }
  else {
    return 0;
  }
};

export const formatGastoFijo = (totalDeuda, estado) => {
  if (totalDeuda && estado) {
    const value = ((totalDeuda * +estado?.porcentual) * +estado?.gastofijo).toFixed(2);

    if (+value > estado.jus) {
      return estado.jus;
    }
    else {
      return +value;
    }
  }
  else {
    return 0;
  }
};

export function formatDeudas(array, situaciones) {
  if (array && array.length) {
    let resultSlice = sliceByYear(array);

    let result = resultSlice.reduce((a, b) => {
      b.forEach((e) => {
        const situacion = situaciones.find((s) => s.CODIGO === e.SITUACION);

        if (a[e.SITUACION]) {
          a[e.SITUACION] = {
            ...a[e.SITUACION],
            [e.ANIO]: {
              anio: e.ANIO,
              legal: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].legal ? a[e.SITUACION][e.ANIO].legal : e.LEGAL,
              periodos: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].periodos ? [...a[e.SITUACION][e.ANIO].periodos, e.CUOTA] : [e.CUOTA],
              monto: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].monto ? [...a[e.SITUACION][e.ANIO].monto, e.TOTAL] : [e.TOTAL],
              estado: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].estado ? [...a[e.SITUACION][e.ANIO].estado, e.ESTADO] : [e.ESTADO],
              situacion: situacion.DETALLE_SITUACION
            }
          };
        }
        else {
          a[e.SITUACION] = {
            [e.ANIO]: {
              anio: e.ANIO,
              legal: e.LEGAL ? e.LEGAL : "",
              periodos: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].periodos ? [...a[e.SITUACION][e.ANIO].periodos, e.CUOTA] : [e.CUOTA],
              monto: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].monto ? [...a[e.SITUACION][e.ANIO].monto, e.TOTAL] : [e.TOTAL],
              estado: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].estado ? [...a[e.SITUACION][e.ANIO].estado, e.ESTADO] : [e.ESTADO],
              situacion: situacion.DETALLE_SITUACION
            }
          };
        }
      }
      );
      return a;
    }, {}
    );
    return result;
  } else {
    return false;
  }
}

export function diffDays(date) {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const limitDate = moment(date).add(90, "days").format("YYYY-MM-DD");

  let firstDate = new Date();
  let secondDate = new Date(limitDate);

  const diffDays = Math.round((secondDate - firstDate) / oneDay);

  return diffDays;
}